"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-c29a9a48"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    id: "local-dialing",
    class: "dialing-local"
};
var _hoisted_2 = { class: "dialing-content" };
var _hoisted_3 = { class: "dialing-user-id" };
var _hoisted_4 = {
    key: 1,
    class: "microphone-icon-container"
};
var _hoisted_5 = { class: "dialing-info" };
var store_1 = require("../store");
var constants_1 = require("../constants");
var MicrophoneIcon_vue_1 = require("./MicrophoneIcon.vue");
var microphoneClosed_vue_1 = require("../icons/microphoneClosed.vue");
var utils_1 = require("../utils");
var reactivity_1 = require("@vue/reactivity");
exports.default = vue_1.defineComponent({
    __name: 'Dialing',
    setup: function (__props) {
        var opacityValue = reactivity_1.computed(function () {
            return (store_1.status.value === constants_1.STATUS.DIALING_C2C && store_1.callType.value === constants_1.CALL_TYPE_STRING.VIDEO) ? "1" : "0.7";
        });
        return function (_ctx, _cache) {
            var _a, _b;
            return (vue_2.openBlock(), vue_2.createElementBlock("div", {
                class: "dialing-wrapper",
                style: vue_2.normalizeStyle("opacity: " + vue_2.unref(opacityValue))
            }, [
                (vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).DIALING_C2C && vue_2.unref(store_1.callType) === vue_2.unref(constants_1.CALL_TYPE_STRING).VIDEO)
                    ? (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1))
                    : vue_2.createCommentVNode("", true),
                vue_2.withDirectives(vue_2.createElementVNode("div", _hoisted_2, [
                    vue_2.createElementVNode("div", _hoisted_3, [
                        (vue_2.unref(store_1.remoteList).length >= 1)
                            ? (vue_2.openBlock(), vue_2.createElementBlock(vue_2.Fragment, { key: 0 }, [
                                vue_2.createTextVNode(vue_2.toDisplayString((_a = vue_2.unref(store_1.remoteList)[0]) === null || _a === void 0 ? void 0 : _a.nick), 1)
                            ], 64))
                            : vue_2.createCommentVNode("", true),
                        (vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).CALLING_C2C_AUDIO)
                            ? (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_4, [
                                ((_b = vue_2.unref(store_1.remoteList)[0]) === null || _b === void 0 ? void 0 : _b.microphone)
                                    ? (vue_2.openBlock(), vue_2.createBlock(MicrophoneIcon_vue_1.default, {
                                        key: 0,
                                        volume: vue_2.unref(store_1.getVolumeByUserID)(vue_2.unref(store_1.remoteList)[0].userID)
                                    }, null, 8, ["volume"]))
                                    : (vue_2.openBlock(), vue_2.createBlock(microphoneClosed_vue_1.default, { key: 1 }))
                            ]))
                            : vue_2.createCommentVNode("", true)
                    ]),
                    vue_2.createElementVNode("div", _hoisted_5, vue_2.toDisplayString(vue_2.unref(store_1.dialingInfo)), 1)
                ], 512), [
                    [vue_2.vShow, !(vue_2.unref(utils_1.isMobile) && vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).DIALING_C2C && vue_2.unref(store_1.callType) === vue_2.unref(constants_1.CALL_TYPE_STRING).VIDEO)]
                ])
            ], 4));
        };
    }
});
